// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import Enums from '../Enums';

export class MaterialSummary {
  readonly id: string;
  readonly name: string;
  readonly alternateID: string | null;
  readonly materialType: Enums.MaterialType;
  readonly inProductCost: string | null;
  readonly inProductCostUnit: string | null;
  readonly plantName: string;
  readonly supplierCompany: string | null;
  readonly rawMaterialCost: string;
  readonly rawMaterialCostUnit: string | null;
  readonly haulingCost: string | null;
  readonly haulingCostUnit: string | null;
  readonly plantLoadingCost: string | null;
  readonly plantLoadingCostUnit: string | null;
  readonly plantId: string;
  readonly marketId: string;
  readonly divisionId: string | null;
  readonly externalID: string | null;
  readonly isArchived: boolean;
  readonly plantIsArchived: boolean;
  readonly currencyCode: Enums.CurrencyCode;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.alternateID = data.alternateID === undefined ? null : data.alternateID;
    this.materialType =
      data.materialType === undefined ? Enums.MaterialType.Aggregate : data.materialType;
    this.inProductCost = data.inProductCost === undefined ? null : data.inProductCost;
    this.inProductCostUnit = data.inProductCostUnit === undefined ? null : data.inProductCostUnit;
    this.plantName = data.plantName === undefined ? '' : data.plantName;
    this.supplierCompany = data.supplierCompany === undefined ? null : data.supplierCompany;
    this.rawMaterialCost = data.rawMaterialCost === undefined ? '' : data.rawMaterialCost;
    this.rawMaterialCostUnit =
      data.rawMaterialCostUnit === undefined ? null : data.rawMaterialCostUnit;
    this.haulingCost = data.haulingCost === undefined ? null : data.haulingCost;
    this.haulingCostUnit = data.haulingCostUnit === undefined ? null : data.haulingCostUnit;
    this.plantLoadingCost = data.plantLoadingCost === undefined ? null : data.plantLoadingCost;
    this.plantLoadingCostUnit =
      data.plantLoadingCostUnit === undefined ? null : data.plantLoadingCostUnit;
    this.plantId = data.plantId === undefined ? NIL_UUID : data.plantId;
    this.marketId = data.marketId === undefined ? NIL_UUID : data.marketId;
    this.divisionId = data.divisionId === undefined ? null : data.divisionId;
    this.externalID = data.externalID === undefined ? null : data.externalID;
    this.isArchived = data.isArchived === undefined ? false : data.isArchived;
    this.plantIsArchived = data.plantIsArchived === undefined ? false : data.plantIsArchived;
    this.currencyCode =
      data.currencyCode === undefined ? Enums.CurrencyCode.USD : data.currencyCode;
  }

  static zero(): MaterialSummary {
    const zeroValues: ExcludeMethodsDeep<MaterialSummary> = {
      id: NIL_UUID,
      name: '',
      alternateID: null,
      materialType: Enums.MaterialType.Aggregate,
      inProductCost: null,
      inProductCostUnit: null,
      plantName: '',
      supplierCompany: null,
      rawMaterialCost: '',
      rawMaterialCostUnit: null,
      haulingCost: null,
      haulingCostUnit: null,
      plantLoadingCost: null,
      plantLoadingCostUnit: null,
      plantId: NIL_UUID,
      marketId: NIL_UUID,
      divisionId: null,
      externalID: null,
      isArchived: false,
      plantIsArchived: false,
      currencyCode: Enums.CurrencyCode.USD,
    };
    return new MaterialSummary(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type MaterialSummaryWireFormat = {
  id: string;
  name: string;
  alternateID: string | null;
  materialType: string;
  inProductCost: string | null;
  inProductCostUnit: string | null;
  plantName: string;
  supplierCompany: string | null;
  rawMaterialCost: string;
  rawMaterialCostUnit: string | null;
  haulingCost: string | null;
  haulingCostUnit: string | null;
  plantLoadingCost: string | null;
  plantLoadingCostUnit: string | null;
  plantId: string;
  marketId: string;
  divisionId: string | null;
  externalID: string | null;
  isArchived: boolean;
  plantIsArchived: boolean;
  currencyCode: string;
};

type NewMaterialSummaryProps = PartialDeep<MaterialSummary, { recurseIntoArrays: true }>;
export const NewMaterialSummary: (props: NewMaterialSummaryProps) => MaterialSummary = (props) =>
  new MaterialSummary(props);

type NewMaterialSummaryFromWireFormatProps = PartialDeep<
  MaterialSummaryWireFormat,
  { recurseIntoArrays: true }
>;
export const NewMaterialSummaryFromWireFormat: (
  props: NewMaterialSummaryFromWireFormatProps,
) => MaterialSummary = (props) => new MaterialSummary(props);
